import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-full-calendar-event',
	templateUrl:'./FullCalendarEventPluginCompPage.html',
	styles: [],
	styleUrls:['./FullCalendarEventPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FullCalendarEventPluginCompPage
{
	mdContent_963 = `\`\`\`java
import com.jwebmp.plugins.fullcalendar.options.FullCalendarEvent;
\`\`\``;
	mdContent_964 = `\`\`\`java
new FullCalendarEvent<>()
    .setId("evt-1")
    .setTitle("Team Meeting")
    .setStart(LocalDateTime.of(2026, 5, 10, 14, 0))
    .setEnd(LocalDateTime.of(2026, 5, 10, 15, 30))
    .setColor("#2196F3")
    .setEditable(true);
\`\`\``;
	mdContent_965 = `\`\`\`java
new FullCalendarEvent<>()
    .setTitle("Conference")
    .setAllDay(true)
    .setStart(LocalDateTime.of(2026, 6, 1, 0, 0))
    .setEnd(LocalDateTime.of(2026, 6, 3, 0, 0))
    .setResourceId(List.of("room-a"))
    .setDisplay("background");
\`\`\``;
}
